<template>
  <div class="card-header m-b-10">
    <form
      class="box-search"
      @reset.prevent="triggerFilter(false)"
      @submit.prevent="triggerFilter()"
    >
      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.merchantInfo"
          class="form-control f12 hc-37"
          placeholder="Thông tin MC"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.categoryName"
          :options="deviceOptions"
          placeholder="Tên thiết bị"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.deviceSerial"
          class="form-control f12 hc-37"
          placeholder="Mã Serial"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.carrierName"
          :options="carrierOptions"
          placeholder="Đơn vị vận chuyển"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.trackingCode"
          class="form-control f12 hc-37"
          placeholder="Mã vận đơn"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.feeType"
          :options="feeTypeOptions"
          placeholder="Hình thức bàn giao"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.shippingStatus"
          :options="shippingStatusOption"
          placeholder="Trạng thái giao hàng"
        />
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="fieldSearch.deliveryDate"
          :locale-data="Config.localeData"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Ngày giao hàng
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="fieldSearch.deliveryDate.startDate || fieldSearch.deliveryDate.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(fieldSearch.deliveryDate)"
        >
          ✕
        </span>
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.approvedStatus"
          :options="approvedOptions"
          placeholder="Trạng thái duyệt"
        />
      </div>

      <div class="form-group form-group-action action-h">
        <button type="submit" ref="submitButtonRef" class="pt-2 mr-2 btn btn-primary hc-37">
          <i class="bx bx-filter-alt"></i> Lọc
        </button>
        <button type="reset" class="pt-2 mr-2 btn btn-outline-light hc-37">
          <i class="bx bx-filter-alt"></i> Bỏ lọc
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { showMess } from '@/config/utils'
  import moment from 'moment'
  import { DeviceService } from '@/services/device.service'
  const searchDefault = {
    merchantInfo: '',
    categoryName: '',
    deviceSerial: '',
    carrierName: '',
    trackingCode: '',
    feeType: '',
    shippingStatus: '',
    approvedStatus: '',
    deliveryDate: {
      startDate: null,
      endDate: null,
    },
  }
  const feeType = Object.freeze([
    { id: 'OFFLINE', text: 'Offline' },
    { id: 'ONLINE', text: 'Online' },
  ])
  export default {
    name: 'FilterShippingForm',
    data() {
      return {
        Config,
        fieldSearch: { ...cloneDeep(searchDefault) },
        listDevices: [],
        feeType,
      }
    },
    computed: {
      deviceOptions() {
        return this.Config.getSearch(this.listDevices)
      },
      feeTypeOptions() {
        return this.Config.getSearch(this.feeType)
      },
      shippingStatusOption() {
        return this.Config.getSearch(this.Config.ShippingStatus).filter(e => e.id !== 'NEW')
      },
      carrierOptions() {
        return this.Config.getSearch(this.Config.listCarrierName)
      },
      approvedOptions() {
        return this.Config.getSearch(this.Config.ShippingApprovedSatus)
      },
    },
    async mounted() {
      await this.fetchDevices()
    },
    methods: {
      triggerFilter(isFilter = true) {
        if (!isFilter) {
          this.fieldSearch = { ...cloneDeep(searchDefault) }
        }
        const params = this.params()
        this.$emit('change', params)
      },
      clearTime(value) {
        value.startDate = null
        value.endDate = null
      },
      params() {
        const body = {}
        if (this.fieldSearch.merchantInfo.trim())
          body.merchantInfo = this.fieldSearch.merchantInfo.trim()
        if (this.fieldSearch.categoryName && this.fieldSearch.categoryName !== '0')
          body.categoryName = this.fieldSearch.categoryName
        if (this.fieldSearch.deviceSerial) body.deviceSerial = this.fieldSearch.deviceSerial.trim()
        if (this.fieldSearch.carrierName) body.carrierName = this.fieldSearch.carrierName
        if (this.fieldSearch.trackingCode) body.trackingCode = this.fieldSearch.trackingCode.trim()
        if (this.fieldSearch.feeType && this.fieldSearch.feeType !== '0')
          body.feeType = this.fieldSearch.feeType
        if (this.fieldSearch.shippingStatus && this.fieldSearch.shippingStatus !== '0')
          body.shippingStatus = this.fieldSearch.shippingStatus
        if (this.fieldSearch.approvedStatus && this.fieldSearch.approvedOptions !== '0')
          body.approvedStatus = this.fieldSearch.approvedStatus
        if (this.fieldSearch.deliveryDate.startDate || this.fieldSearch.deliveryDate.endDate) {
          body.deliveryStart = moment(this.fieldSearch.deliveryDate.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()
          body.deliveryEnd = moment(this.fieldSearch.deliveryDate.endDate)
            .endOf('day')
            .add(7, 'hours')
            .valueOf()
        }
        return body
      },
      async fetchDevices() {
        try {
          const response = await DeviceService.typeDeviceConfig()
          if (response.code === 1000) {
            this.listDevices = response.data.map(e => {
              return {
                id: e.nickname,
                text: e.name,
              }
            })
          } else {
            showMess(this, 'Error', response.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        }
      },
    },
  }
</script>

<style scoped>
  .action-h {
    height: 41px;
  }
</style>
